import { useState, useEffect } from 'react';
import axios from 'axios';
import { BookOpen, Heart, Sparkles } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const About = () => {
  const [settings, setSettings] = useState({
    store_name: 'Brookzone Bookseller',
    about_text: '',
    about_story: ''
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/settings`);
        setSettings(response.data);
      } catch (error) {
        console.error('Failed to fetch settings:', error);
      }
    };
    fetchSettings();
  }, []);

  return (
    <div data-testid="about-page">
      {/* Hero */}
      <section className="relative h-64 sm:h-80 overflow-hidden">
        <img
          src="https://images.pexels.com/photos/2041540/pexels-photo-2041540.jpeg"
          alt="Cozy bookstore"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary/90 to-primary/40" />
        <div className="absolute inset-0 flex flex-col justify-center items-center text-white p-4">
          <h1 className="font-serif text-4xl sm:text-5xl font-bold mb-2 text-center">
            Our Story
          </h1>
          <p className="text-white/90 text-center max-w-xl">
            Get to know {settings.store_name}
          </p>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Main Story */}
        <div className="prose prose-lg max-w-none mb-16">
          <div className="flex items-center gap-3 mb-6">
            <BookOpen className="h-8 w-8 text-primary" />
            <h2 className="font-serif text-2xl font-bold text-foreground m-0">Welcome to {settings.store_name}</h2>
          </div>
          <p className="text-foreground/80 leading-relaxed text-lg">
            {settings.about_story || "Founded with a passion for books and wellness products, Brookzone Bookseller has been serving our community with carefully curated collections of books, healing crystals, aromatic incense, handcrafted soaps, unique toys, and thoughtful gifts. We believe in nurturing the mind, body, and spirit through quality products and exceptional service."}
          </p>
        </div>

        {/* Values */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="text-center p-6 bg-muted/50 rounded-lg">
            <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <BookOpen className="h-6 w-6 text-primary" />
            </div>
            <h3 className="font-serif text-lg font-semibold mb-2">Curated Selection</h3>
            <p className="text-muted-foreground text-sm">
              Every item in our store is carefully chosen to inspire and delight.
            </p>
          </div>
          <div className="text-center p-6 bg-muted/50 rounded-lg">
            <div className="w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Heart className="h-6 w-6 text-accent" />
            </div>
            <h3 className="font-serif text-lg font-semibold mb-2">Community First</h3>
            <p className="text-muted-foreground text-sm">
              We&apos;re more than a store - we&apos;re a gathering place for like-minded souls.
            </p>
          </div>
          <div className="text-center p-6 bg-muted/50 rounded-lg">
            <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Sparkles className="h-6 w-6 text-secondary" />
            </div>
            <h3 className="font-serif text-lg font-semibold mb-2">Quality & Care</h3>
            <p className="text-muted-foreground text-sm">
              We source products that are meaningful, sustainable, and made with love.
            </p>
          </div>
        </div>

        {/* Mission */}
        <div className="bg-primary text-primary-foreground rounded-lg p-8 text-center">
          <h2 className="font-serif text-2xl font-bold mb-4">Our Mission</h2>
          <p className="text-primary-foreground/90 max-w-2xl mx-auto">
            {settings.about_text || "To create a welcoming space where everyone can discover treasures that nurture the mind, body, and spirit. We&apos;re dedicated to bringing you quality products, thoughtful service, and a little bit of magic in everything we do."}
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
